import {
  inquiryReviewTypeDict,
  onlineReviewScoreStatusDict,
  onlineReviewStatusDict
} from '@/dictionary/project/online-review'
import { arrToObj } from '@/utils/utils'

const useOnlineReviewTask = reviewProject => {
  // 评审办法列表
  const wayInfoList = reviewProject?.wayInfoList || []
  // 评审办法汇总列表
  const summaryList = reviewProject?.summaryList || []
  // 是否终止评审
  const isReviewClose = !!(reviewProject?.isReviewClose || false)

  const endStatus = [
    onlineReviewStatusDict.END.value,
    onlineReviewStatusDict.REPORTED.value
  ]
  const reviewClosed = endStatus.includes(reviewProject.reviewStatus)

  /**
   * 获取任务列表
   */
  const getReviewTaskList = () => {
    const taskList = getTaskListFromProject(wayInfoList, summaryList)
    const endTask = getEndTask(taskList)
    taskList.push(endTask)
    return taskList
  }

  /**
   * 从项目信息中获取评审任务步骤列表
   * @param {Array} wayList 评审办法列表
   * @param {Array} summaryList 评审办法汇总列表
   * @returns {[]} 评审任务列表
   */
  const getTaskListFromProject = (wayList, summaryList) => {
    const summaryMap = arrToObj(summaryList, 'wayId')
    return (wayList || []).map(item => {
      // 汇总信息
      const summaryInfo = summaryMap[item.wayId] || {}
      // 副标题
      let subTitle = ''
      if (
        isReviewClose &&
        summaryInfo?.summaryStatus === onlineReviewScoreStatusDict.PENDING.value
      ) {
        subTitle = `(终止不可评)`
      } else {
        subTitle = `(${
          onlineReviewScoreStatusDict.translate(summaryInfo?.summaryStatus)
            ?.subTitle
        })`
      }
      // 标题
      const title = inquiryReviewTypeDict.translate(item.wayType)?.label
      // 当前评审任务是否不可点击
      const disabled =
        summaryInfo?.summaryStatus === onlineReviewScoreStatusDict.PENDING.value
      return {
        wayId: item.wayId,
        summaryStatus: summaryInfo.summaryStatus,
        label: title,
        subTitle,
        disabled,
        ...item
      }
    })
  }

  /**
   * 获取评审结束节点
   * @param {Array} taskList 评审任务列表
   */
  const getEndTask = taskList => {
    let subTitle = onlineReviewScoreStatusDict.PENDING.subTitle
    const lastStep = taskList[taskList.length - 1]
    let lastStepCompleted =
      lastStep.summaryStatus === onlineReviewScoreStatusDict.COMPLETED.value
    let endProcessStatus = onlineReviewScoreStatusDict.PENDING.value
    if (lastStepCompleted) {
      endProcessStatus = onlineReviewScoreStatusDict.REVIEWING.value
      subTitle = onlineReviewScoreStatusDict.REVIEWING.subTitle
    }
    if (reviewClosed) {
      endProcessStatus = onlineReviewScoreStatusDict.COMPLETED.value
      subTitle = onlineReviewScoreStatusDict.COMPLETED.subTitle
    }
    if (isReviewClose) {
      subTitle = '(终止自动结束)'
      lastStepCompleted = true
      endProcessStatus = onlineReviewScoreStatusDict.COMPLETED.value
    }

    return {
      label: '确认评标结束',
      subTitle,
      wayId: 0,
      summaryStatus: endProcessStatus,
      disabled: !lastStepCompleted,
      wayType: 'end'
    }
  }

  /**
   * 获取默认跳转的任务下标
   * @param {Array} taskList 任务列表
   */
  const getDefaultTaskIndex = (taskList, wayId) => {
    if (wayId > 0) {
      return taskList.findIndex(item => item.wayId === wayId)
    }

    const {
      REVIEWING,
      PENDING,
      RESTART,
      COMPLETED
    } = onlineReviewScoreStatusDict

    const taskRouteList = [REVIEWING, PENDING, RESTART, COMPLETED]
    const taskRouteObj = arrToObj(taskRouteList, 'value')
    let stepIndex = 0
    taskRouteList
      .map(item => item.value)
      .some(key => {
        stepIndex = taskList.findIndex(item => {
          return item.summaryStatus === taskRouteObj[key]?.value
        })
        return stepIndex >= 0
      })

    // 如果全部已汇总，则跳转到评审结束页面
    const allSummary = taskList.every(
      item => item.summaryStatus === onlineReviewScoreStatusDict.COMPLETED.value
    )
    if (allSummary) {
      stepIndex = taskList.length - 1
    }
    const taskIndex = stepIndex < 0 ? 0 : stepIndex
    return taskIndex
  }

  return {
    getReviewTaskList,
    getDefaultTaskIndex
  }
}

export default useOnlineReviewTask
